import Vue from 'vue'
import VueRouter from 'vue-router'
import { initAuth, isLoggedIn } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/Landing.vue')
  },
  {
    path: '/analyze',
    name: 'Usage',
    component: () => import('@/views/Usage.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/History.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/points',
    name: 'Points',
    component: () => import('@/views/Points.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/points/recharge',
    name: 'PointsRecharge',
    component: () => import('@/views/PointsRecharge.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  {
    path: '/terms',
    name: 'TermsOfUse',
    component: () => import('@/views/TermsOfUse.vue')
  },
  {
    path: '/careers',
    name: 'Careers',
    component: () => import('@/views/Careers.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  initAuth()

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  if (to.meta.guest && isLoggedIn()) {
    next(to.query.redirect || '/analyze')
    return
  }

  next()
})

export default router
